import DetailsHeader from 'app/components/common/reports/DetailsHeader'

import { useReportAllSchoolsAllowancesDto } from '../../_common/useReportAllSchoolsAllowancesDto'
import { useReportTotalsDto } from '../../_common/useReportTotalsDto'
import { useReportAllowances } from '../../_common/useReportAllowances'
import { ByAllowancesTable } from './ByAllowancesTable'


export const ByAllowances = () => {
  const allowances = useReportAllowances()
  const allSchoolsAllowancesDto = useReportAllSchoolsAllowancesDto()
  const totalsDto = useReportTotalsDto()

  if (!allowances || !allSchoolsAllowancesDto || !totalsDto) return null

  return (
    <>
      <DetailsHeader reportTitle="Дотации" />
      <ByAllowancesTable
        allowances={allowances}
        allSchoolsAllowancesDto={allSchoolsAllowancesDto}
        totalsDto={totalsDto}
      />
    </>
  )
}
